// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import physics_tool from "../../engines/libs/physics_tool";
import plane from "./prefab/plane";
import {GameClient} from "../../engines/managers/gameSocketManager";
import {$WS} from "../../WsSdk/webSocketProtocol/webSocketProtoHead";
import {managers, modules, services} from "../../engines/gameEngine";
import enemy from "./prefab/enemy";
import bomb from "./prefab/bomb";
import did from "./prefab/did";
import SSubUpdateHostUid from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubUpdateHostUid";
import CSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/CSubMatchRoom";
import SSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubMatchRoom";
import SSubObGameStart from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubObGameStart";
import SSubExitRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubExitRoom";
import SSubSyncScore from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubSyncScore";
import SSubUpdateHurtHp from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubUpdateHurtHp";
import SSubKillEnemy from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubKillEnemy";
import SSubPlaneMove from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubPlaneMove";
import SSubNewEnemy from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubNewEnemy";
import data_control from "../../engines/libs/data_control";
import CSubShopBullet from "../../WsSdk/webSocketProtocol/onlineBattleList/CSubShopBullet";
import SSubShopBullet from "../../WsSdk/webSocketProtocol/onlineBattleList/SSubShopBullet";
import SCSubGameSync from "../../WsSdk/webSocketProtocol/wsInstanceList/SCSubGameSync";

const {ccclass, property} = cc._decorator;

export interface EnemyIdPool {
    [id: number]: enemy;
}

const NAME_KEY = 'plane-name';

export interface PlanePool {
    [id: string]: plane;
}

@ccclass
export default class battleMode extends cc.Component implements GameClient {

    readonly gameId: number = 101;
    readonly gameName: string = '联机对战Demo';

    sendGameMessage(cMsg: Uint8Array): void {
        managers().socketMgr.sendGameMessage(cMsg);
    }

    sendHallMessage(cMsg: $WS.WebSocketProtoHeadBody): void {
        managers().socketMgr.sendHallMessage(cMsg);
    }

    sendSyncMessage(msg: Uint8Array) {
        managers().socketMgr.sendMessage(msg);
    }

    private m_hostId: string;

    @property(cc.Node)
    gameLayer: cc.Node = null;
    @property(cc.Node)
    lEnemy: cc.Node = null;
    @property(cc.Node)
    lPlane: cc.Node = null;
    @property(cc.Node)
    lBullet: cc.Node = null;
    @property(cc.Node)
    lbEffect: cc.Node = null;
    @property(cc.Node)
    lScore: cc.Node = null;
    @property(cc.Prefab)
    pbPlane: cc.Prefab = null;
    @property(cc.Prefab)
    pbBullet: cc.Prefab = null;
    @property(cc.Prefab)
    pbEnemy: cc.Prefab = null;
    @property(cc.Prefab)
    pbBomb: cc.Prefab = null;
    @property(cc.Prefab)
    pbDid: cc.Prefab = null;
    @property(cc.Prefab)
    pbScore: cc.Prefab = null;
    @property(cc.Node)
    ndWaitTeam: cc.Node = null;
    @property(cc.Node)
    ndGetName: cc.Node = null;
    @property(cc.EditBox)
    editName: cc.EditBox = null;
    @property(cc.Label)
    lbRank: cc.Label = null;
    @property(cc.Label)
    lbGameRun: cc.Label = null;
    @property(cc.ScrollView)
    svGameRun: cc.ScrollView = null;
    @property(cc.Label)
    lbMeScore: cc.Label = null;
    @property(cc.Label)
    lbShopTime: cc.Label = null;
    @property(cc.Label)
    lbRoomInfo: cc.Label = null;

    protected m_bulletPool: cc.NodePool;
    protected m_enemyPool: cc.NodePool;
    protected m_bombPool: cc.NodePool;
    protected m_didPool: cc.NodePool;
    //
    protected m_players: PlanePool = {};
    //
    protected m_enemyMap: EnemyIdPool;

    onLoad() {
        physics_tool.openPhysics(false);
        managers().socketMgr.registerGameClient(this);
    }

    start() {
        this.m_bulletPool = new cc.NodePool();
        this.m_enemyPool = new cc.NodePool();
        this.m_bombPool = new cc.NodePool();
        this.m_didPool = new cc.NodePool();
        this.m_enemyMap = {};
        this.lbRank.string = '';
        //
        this.onSetName();
        //
    }

    onSetName() {
        this.ndWaitTeam.active = false;
        this.ndGetName.active = true;
        const name = services().localStorageSrv.getStorage(NAME_KEY);
        this.editName.string = name || '';
    }

    getMeName() {
        return this.editName.string;
    }

    protected onBtnShopGun() {
        const p = this.getMePlane();
        if (p) {
            const msg = new CSubShopBullet();
            this.sendGameMessage(msg.getPackageBody(this.gameId));
            // 
        }
    }

    protected onBtnSubmit() {
        const name = this.editName.string;
        if (name.trim().length <= 0) {
            modules().uiControlModule.showMessageBox('请输入有效名字');
            return;
        }
        services().localStorageSrv.setStorage(NAME_KEY, name);
        this.ndGetName.active = false;
        this.onGoRoom();
    }

    getUserId() {
        return managers().socketMgr.getUserId();
    }

    getSeatId() {
        return managers().socketMgr.getSeatI();
    }

    onGoRoom() {
        this.ndWaitTeam.active = true;
        const msg = new CSubMatchRoom(this.getMeName());
        this.sendGameMessage(msg.getPackageBody(this.gameId));
    }

    onUserExit(msg: SSubExitRoom) {
        const plane = this.getPlaneOfUid(msg.body.uid);
        if (plane) {
            this.addGameRunInfo(`${plane.getName()}离开了游戏`);
            delete this.m_players[plane.getUid()];
            plane.node.destroy();
        }
    }

    getPlaneOfUid(uid: string) {
        return this.m_players[uid];
    }

    onMeKillEnemy(msg: SSubKillEnemy) {
        const {body} = msg;
        const enemy = this.getEnemyById(body.eid);
        if (enemy) {
            let pos = enemy.node.getPosition().clone();
            this.addDid(pos);
            this.destroyEnemy(body.eid, enemy.node);
            //自己
            if (body.seatId == this.getSeatId()) {
                //
                const node = cc.instantiate(this.pbScore);
                this.lScore.addChild(node);
                node.setPosition(pos);
                node.scale = 0.1;
                node.getComponent(cc.Label).string = `+${body.score}`;
                cc.tween(node)
                    .to(0.2, {scale: 1})
                    .to(2, {opacity: 128})
                    .call(() => {
                        node.destroy();
                    })
                    .start();
            }
        }
    }

    protected addPlane(uid: string, seat: number): plane {
        console.warn('添加飞机x', Object.keys(this.m_players).length);
        const node = cc.instantiate(this.pbPlane);
        this.lPlane.addChild(node);
        const sPos = cc.find('startPos', this.lPlane).getPosition();
        node.setPosition(0, sPos.y);
        this.m_players[uid] = node.getComponent(plane);
        this.m_players[uid].bindData(uid, seat, this, seat);
        console.warn('添加飞机y', Object.keys(this.m_players).length);
        return node.getComponent(plane);
    }

    onGameStart(msg: SSubObGameStart) {
        console.debug('游戏开始消息', msg);
        this.ndWaitTeam.active = false;
        const {pUidList, pSeatList, pNameList, pScoreList, pPosXList, pPosYList} = msg.body;
        //plane
        for (let i = 0; i < pUidList.length; i++) {
            const uid = pUidList[i];
            const x = pPosXList[i];
            const y = pPosYList[i];
            const score = pScoreList[i];
            const name = pNameList[i];
            let p = this.getPlaneOfUid(uid);
            if (!p) {
                //自己的飞机走进入房间时加载
                if (uid != this.getUserId()) {
                    p = this.addPlane(pUidList[i], pSeatList[i]);
                }
            }
            if (p) {
                p.setName(name);
                p.onMove(x, y);
                p.onNetSetScore(score);
            }
        }
    }

    addEnemy(eid: number, pos: { x: number, y: number }, time: number, hp: number) {
        let node = this.m_enemyPool.get();
        if (!node) {
            node = cc.instantiate(this.pbEnemy);
        }
        //
        this.lEnemy.addChild(node);
        //
        node.setPosition(pos.x, pos.y);
        cc.Tween.stopAllByTarget(node);
        cc.tween(node)
            .by(time, {y: -2640})
            .start();
        const com = node.getComponent(enemy);
        com.bindData(eid, this, hp);
        this.m_enemyMap[eid] = com;
    }

    destroyEnemy(eid: number, node: cc.Node) {
        delete this.m_enemyMap[eid];
        this.m_enemyPool.put(node);
    }

    getEnemyById(eid: number) {
        return this.m_enemyMap[eid];
    }

    addBullet() {
        let node = this.m_bulletPool.get();
        if (!node) {
            node = cc.instantiate(this.pbBullet);
        }
        this.lBullet.addChild(node);
        return node;
    }

    addBomb(pos: cc.Vec2) {
        let node = this.m_bombPool.get();
        if (!node) {
            node = cc.instantiate(this.pbBomb);
        }
        this.lbEffect.addChild(node);
        node.setPosition(pos);
        node.getComponent(bomb).bindData(this);
        return node;
    }

    addDid(pos: cc.Vec2) {
        let node = this.m_didPool.get();
        if (!node) {
            node = cc.instantiate(this.pbDid);
        }
        this.lbEffect.addChild(node);
        node.getComponent(did).bindData(this);
        node.setPosition(pos);
        return node;
    }

    destroyDid(node: cc.Node) {
        this.lbEffect.removeChild(node);
        this.m_didPool.put(node);
    }

    destroyBomb(node: cc.Node) {
        this.lEnemy.removeChild(node);
        this.m_bombPool.put(node);
    }

    destroyBullet(node: cc.Node) {
        this.lBullet.removeChild(node);
        this.m_bulletPool.put(node);
    }

    isHost() {
        return this.m_hostId == managers().socketMgr.getUserId();
    }

    onGameSyncMessage(msg: SCSubGameSync): Promise<void> {
        console.debug('同步消息', msg);
        const {seat, syncs} = msg.body;
        if (seat == this.getMePlane().getSeatI()) return;
        const p = this.getPlaneOfSeatI(seat);
        if (p) {
            p.onMove(syncs[0], syncs[1]);
        }
        return Promise.resolve();
    }

    onGameMessage(head: number, body: Uint8Array): Promise<void> {
        // console.debug('游戏消息HEAD', head);
        switch (head) {
            case SSubUpdateHostUid.HEAD: {
                this.onUpdateHostUid(SSubUpdateHostUid.unPackageMessage(body));
                break;
            }
            case SSubMatchRoom.HEAD: {
                this.onUserJoinRoom(SSubMatchRoom.unPackageMessage(body));
                break;
            }
            case SSubExitRoom.HEAD: {
                this.onUserExit(SSubExitRoom.unPackageMessage(body));
                break;
            }
            case SSubObGameStart.HEAD: {
                this.onGameStart(SSubObGameStart.unPackageMessage(body));
                break;
            }
            case SSubNewEnemy.HEAD: {
                this.onNetAddEnemy(SSubNewEnemy.unPackageMessage(body));
                break;
            }
            case SSubSyncScore.HEAD: {
                this.onSyncScore(SSubSyncScore.unPackageMessage(body));
                break;
            }
            case SSubUpdateHurtHp.HEAD: {
                this.onEnemyHpUpdate(SSubUpdateHurtHp.unPackageMessage(body));
                break;
            }
            case SSubKillEnemy.HEAD: {
                this.onMeKillEnemy(SSubKillEnemy.unPackageMessage(body));
                break;
            }
            case SSubPlaneMove.HEAD: {
                this.onMovePos(SSubPlaneMove.unPackageMessage(body));
                break;
            }
            case SSubShopBullet.HEAD: {
                this.onShopAdd(SSubShopBullet.unPackageMessage(body));
                break;
            }
        }
        return Promise.resolve();
    }

    protected onShopAdd(msg: SSubShopBullet): void {
        const p = this.getPlaneOfSeatI(msg.body.seatI);
        if (p) {
            p.addShopTime();
        }
    }

    protected onEnemyHpUpdate(msg: SSubUpdateHurtHp) {
        const {body: detail} = msg;
        const enemy = this.getEnemyById(detail.eid);
        enemy && enemy.onNetHurt(detail.hp);
    }

    protected onMovePos(msg: SSubPlaneMove) {
        const {body} = msg;
        const player = this.getPlaneOfSeatI(body.seat);
        //同步其他人位置
        if (player && player.getSeatI() != this.getSeatId()) {
            player.onMove(body.x, body.y);
        }
    }

    protected onSyncScore(msg: SSubSyncScore) {
        const {seats, scores} = msg.body;
        for (let i = 0; i < seats.length; i++) {
            const player = this.getPlaneOfSeatI(seats[i]);
            //其他人成绩更新
            // if (this.getMePlane().getUid() != player.getUid()) {
            player && player.onNetSetScore(scores[i]);
            // }
            this.onUpdateRank();
        }
    }

    protected onNetAddEnemy(msg: SSubNewEnemy) {
        const detail = msg.body;
        this.addEnemy(detail.eid, {x: detail.x, y: detail.y}, detail.time, detail.hp);
    }

    // update (dt) {}
    private onUpdateHostUid(msg: SSubUpdateHostUid) {
        this.m_hostId = msg.body.uid;
    }

    addGameRunInfo(text: string) {
        this.lbGameRun.string += text + '\n';
        this.svGameRun.scrollToBottom(0.1);
    }

    private onUserJoinRoom(msg: SSubMatchRoom) {
        const {body} = msg;
        const seat = body.seatI;
        let plane = this.getPlaneOfUid(body.userId);
        if (!plane) {
            plane = this.addPlane(body.userId, seat);
        }
        plane.setName(msg.body.userName);
        this.addGameRunInfo(`${plane.getName()}加入房间`);
        if (seat == this.getSeatId()) {
            this.lbRoomInfo.string = `${body.roomId}号房间`;
        }
    }

    getPlaneOfSeatI(seat: number): plane {
        for (const id in this.m_players) {
            const p = this.m_players[id];
            if (p.getSeatI() == seat) {
                return p;
            }
        }
        return null;
    }

    getMePlane(): plane {
        return this.getPlaneOfSeatI(this.getSeatId());
    }

    onUpdateRank() {
        type Rank = { score: number, name: string };
        const list: Rank[] = []
        for (const id in this.m_players) {
            const p = this.m_players[id];
            if (p.getSeatI() >= 0) {
                list.push({score: p.getScore(), name: p.getName()});
            }
        }
        list.sort((a, b) => {
            return b.score - a.score;
        });
        let str = '';
        list.forEach(r => {
            str += `${r.name} ${r.score}\n`;
        })
        this.lbRank.string = str;
    }

    protected update(dt: number) {
        const p = this.getMePlane();
        if (p) {
            this.lbMeScore.string = `${p.getScore()}`;
            this.lbShopTime.string = data_control.getTimeFormatClock(Math.floor(p.getShopTime()));
        } else {
            this.lbShopTime.string = '00:00';
        }
    }
}



























